<project-navigation
  [headerTitle]="'projectNavigation.title_request_multiple_quote'"
  [headerText]="'projectNavigation.text_request_multiple_quote'"
  [model]="model"
  [submitEnabled]="submitEnabled"
  [multipleSelectionWithinSingleProject]="true"
  [actionButtonLabel]="'global.label.next'"
  [selectionAvailable]="true"
  [visibleFeatures]="{
    compositeCheckBox: false,
    pinnedProjects: true,
    recentlyUsedProjects: true,
    history: true,
    projectActionsMenu: false,
    projectGroupContextMenu: false,
    newConfigurationGroupBtn: false,
    newFolderBtn: false,
    dialogSearch: true,
    tabs: false,
    breadcrumbs: false,
  }"
  (submitEnabledChanged)="updateSubmitEnabled()"
  (actionBtnClick)="requestMultipleQuote()"
  (cancel)="cancel()"
></project-navigation>
